export default "__VITE_ASSET__e2cff824__"